import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { AddressProvider } from './contexts/AddressContext';
import { LocationProvider } from './contexts/LocationContext';
import { OrderStatusProvider } from './contexts/OrderStatusContext';

// Customer Pages
import HomePage from './pages/customer/HomePage';
import HomePageNew from './pages/customer/HomePageNew';
import CheckoutPage from './pages/customer/CheckoutPage';
import CheckoutPageNew from './pages/customer/CheckoutPageNew'; // New professional checkout page
import ProfilePage from './pages/customer/ProfilePage';
import OrderHistoryPage from './pages/customer/OrderHistoryPage';
import AddressManagement from './pages/customer/AddressManagement';
import UserLogin from './pages/customer/UserLogin'; // New user login page
import UserProfile from './pages/customer/UserProfile'; // New user profile page
import TestPage from './pages/customer/TestPage';

// Landing and Menu Pages
import LandingPageNew from './pages/LandingPageNew';
import OnlineMenu from './pages/OnlineMenu';

// SEO Pages
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminLoginNew from './pages/admin/AdminLoginNew'; // New professional admin login
import AdminLoginSimple from './pages/admin/AdminLoginSimple'; // Simple admin login for testing
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminDashboardNew from './pages/admin/AdminDashboardNew'; // New professional admin dashboard
import MenuManagement from './pages/admin/MenuManagement';
import MenuManagementNew from './pages/admin/MenuManagementNew'; // New professional menu management
import MenuManagementNewFixed from './pages/admin/MenuManagementNewFixed'; // Fixed menu management without form interference
import OrdersManagement from './pages/admin/OrdersManagement';
import OrdersManagementNew from './pages/admin/OrdersManagementNew'; // New professional orders management
import DiscountsManagement from './pages/admin/DiscountsManagement';
import DiscountsManagementNew from './pages/admin/DiscountsManagementNew'; // New professional discounts management
import DiscountsManagementNewFixed from './pages/admin/DiscountsManagementNewFixed'; // Fixed discounts management without form interference
import CouponsManagement from './pages/admin/CouponsManagement';
import PromotionsManagement from './pages/admin/PromotionsManagement'; // Unified promotions management

// Components
import Cart from './components/Cart';
import CartNew from './components/CartNew';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <AddressProvider>
          <LocationProvider>
            <OrderStatusProvider>
              <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Landing and Menu Routes */}
              <Route path="/" element={<LandingPageNew />} />
              <Route path="/landing" element={<LandingPageNew />} />
              <Route path="/menu" element={<OnlineMenu />} />
              
              {/* SEO Pages */}
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              
              {/* Customer Routes */}
              <Route path="/order" element={<HomePageNew />} />
              <Route path="/old" element={<HomePage />} />
              <Route path="/test" element={<TestPage />} />
              <Route path="/login" element={<UserLogin />} /> {/* New user login route */}
              <Route path="/profile" element={<UserProfile />} /> {/* New user profile route */}
              <Route path="/checkout" element={<CheckoutPageNew />} />
              <Route path="/profile-old" element={<ProfilePage />} />
              <Route path="/orders" element={<OrderHistoryPage />} />
              <Route path="/addresses" element={<AddressManagement />} />
              
                      {/* Admin Routes */}
                      <Route path="/admin/login" element={<AdminLoginSimple />} />
                      <Route path="/admin" element={
                        <ProtectedRoute adminOnly>
                          <AdminDashboardNew />
                        </ProtectedRoute>
                      } />
                      <Route path="/admin/menu" element={
                        <ProtectedRoute adminOnly>
                          <MenuManagementNewFixed />
                        </ProtectedRoute>
                      } />
                      <Route path="/admin/orders" element={
                        <ProtectedRoute adminOnly>
                          <OrdersManagementNew />
                        </ProtectedRoute>
                      } />
                      <Route path="/admin/discounts" element={
                        <ProtectedRoute adminOnly>
                          <DiscountsManagementNewFixed />
                        </ProtectedRoute>
                      } />
              <Route path="/admin/coupons" element={
                <ProtectedRoute adminOnly>
                  <CouponsManagement />
                </ProtectedRoute>
              } />
              <Route path="/admin/promotions" element={
                <ProtectedRoute adminOnly>
                  <PromotionsManagement />
                </ProtectedRoute>
              } />
            </Routes>
            
            {/* Global Cart Component */}
            <CartNew />
            
            {/* Toast Notifications */}
            <Toaster 
              position="top-center"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
              }}
            />
          </div>
                  </Router>
            </OrderStatusProvider>
            </LocationProvider>
          </AddressProvider>
        </CartProvider>
      </AuthProvider>
    );
  }

export default App;
